<template>
  <div>
    <div v-if="cart && cart.items" class="table-responsive">
      <table class="table">
        <thead class="hidden">
          <tr>
            <th><span class="sr-only">#</span></th>
            <th>{{ __t('shop.checkout.cart_item') }}</th>
            <th>{{ __t('shop.checkout.cart_item_quantity') }}</th>
            <th>{{ __t('shop.checkout.cart_item_price') }}</th>
            <th>VAT %</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(cartItem, index) in cart.items">
            <td>
              <img :src="cartItem.imageUrl" style="max-height: 60px" alt="">
            </td>
            <td>
              <span>
                {{ cartItem.name }}
              </span><br>
              <span v-if="cartItem.variant_values">
                <span class="cart-product-description" v-for="(optionName, groupName) in cartItem.variant_values">
                  <span>
                    {{ groupName }}: {{ optionName }}
                  </span><br>
                </span>
              </span>
              <span v-if="cartItem.options.length" class="cart-product-description">
                <span class="cart-product-description" v-for="(option, index) in cartItem.options">
                  <span>
                    {{ option.group_name }}: {{ option.name }}
                  </span><br>
                </span>
              </span>
            </td>
            <td>
               x{{cartItem.quantity}}
            </td>
            <td style="white-space:nowrap">
              <span v-if="cartItem.total_disc_cost && cartItem.total_disc_cost < cartItem.total_cost">
                <span style="margin-right: 5px">
                  <del v-if="b2bEnabled">{{ (cartItem.total_cost - cartItem.vatAmount).toFixed(2) }} {{ currency }}</del>
                  <del v-else> {{ (cartItem.total_cost ).toFixed(2) }} {{ currency }}</del>
                </span>
                 <span v-if="b2bEnabled">
                  {{ (cartItem.total_disc_cost - cartItem.vatAmount).toFixed(2) }} {{ currency }}
                </span> 
                <span v-else>
                    {{ (cartItem.total_disc_cost ).toFixed(2) }} {{ currency }}
                </span>           

                   
              </span>
              <span v-else>
                <span v-if="b2bEnabled && Object.keys(vatCategoryTotals).length > 0">
                  {{ (cartItem.total_cost - cartItem.vatAmount).toFixed(2) }} {{ currency }}
                </span> 
                <span v-else>
                    {{ (cartItem.total_cost) }} {{ currency }}
                </span>               
              </span>
            </td>
          </tr>
        </tbody>

      </table>

      <table class="table table-striped">
        <tr v-for="(discount, index) in cart.discounts">
          <td>
            <div v-if="!discount.has_errors">
              <i class="far fa-tags"></i> {{ discount.name }}
            </div>
            <div class="alert alert-warning" v-else>
              <b>"{{ discount.code }}"</b> {{ discount.error_message }}
            </div>

          </td>
          <td>{{ discount.total_discount }} {{ currency }}</td>
          <td></td>
          <td><a v-if="!discount.automatic" href="#" @click.prevent="removeActiveCoupon(index)"><i
                class="fa fa-trash"></i></a></td>
        </tr>
      </table>

      <div class="text-right">

        <div class="cart-table-net">
          {{ __t('shop.checkout.net_total') }}: {{ cart.cart_cost ? (cart.cart_cost - totalVat).toFixed(2) : '0.00' }} {{
          currency }}
        </div>

        <div class="cart-table-vat" v-if="b2bEnabled && Object.keys(vatCategoryTotals).length > 0">
          <ul>
            <li v-for="(total, categoryName) in vatCategoryTotals" :key="categoryName">
              {{ categoryName }}: {{ total.toFixed(2) }} {{ currency }}
            </li>
          </ul>
        </div>
        <div class="cart-table-discount">
          {{ __t('shop.checkout.discount_total') }}:{{ (totalDiscount) ? (Number(totalDiscount)).toFixed(2) : '0.00' }}
          {{ currency }}
        </div>
        <div class="cart-table-total">
          {{ __t('shop.checkout.total_cost') }}: {{ totalItemsCost ? ((totalItemsCost)) : '0.00' }} {{ currency }}
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
export default {
  data() {
    return {
      currency: window.currency,
      vatPercentages: [],
      vatCategoryTotals: {},
      vatPercentage: null,
    };
  },
  props: {
    cart: Object,
    totalItemsCost: Number,
    totalDiscount: String | Number,
    b2bEnabled: {
      type: String,
      required: true
    },
    defaultVat: {
        type: Object,
        default: null
      },
    companyAlias: String,
  },
  computed: {
    totalVat() {
      let totalVat = 0;
      if (this.b2bEnabled) {
        for (const vatCategory in this.vatCategoryTotals) {
          totalVat += this.vatCategoryTotals[vatCategory];
        }
      }
      return totalVat;
    }
  },
  methods: {
    ...mapActions([
      'removeCoupon'
    ]),
    removeActiveCoupon(index) {
      this.removeCoupon(index);
      this.$emit('remove');
    },
    async fetchVatPercentages() {
      const vatCategoryTotals = {};
      const vatPercentages = [];
      const fetchItemData = async (itemId) => {
        try {
          const response = await $.ajax({
            type: 'GET',
            url: `/companyadmin/shop/items/item/${itemId}`,
            data: {
              company_alias: this.companyAlias,  // Send company ID in the body
            },
          });
          return response.data;
        } catch (error) {
          console.error('Error fetching item data:', error);
          throw error;
        }
      };
      const fetchVatCategory = async (vatCategoryId) => {
        try {
          const response = await $.ajax({
            type: 'GET',
            url: route('webapp.shop.vat_category',  {alias: window.company_alias, vatCategory_id : vatCategoryId }),
          });
          return response;
        } catch (error) {
          console.error('Error fetching VAT category:', error);
          throw error;
        }
      };
      const calculateVatAmount = (quantity, unitCost, vatPercentage) => {
        return parseFloat(quantity * unitCost) - parseFloat(quantity * unitCost) / (1 + vatPercentage / 100);
      };
      for (const cartItem of this.cart.items) {
        const itemId = cartItem.item_id;
        const itemData = await fetchItemData(itemId);
        const vatCategoryId = itemData.vat_category_id;
        let vatPercentage, vatAmount, vatName;

        if (this.b2bEnabled === "true" && !itemData.include_vat) {
          if (vatCategoryId) {
            const vatCategory = await fetchVatCategory(vatCategoryId);
            vatPercentage = vatCategory.percentage;
            vatName = vatCategory.name;
          } else {
            vatPercentage = parseFloat(this.defaultVat.percentage).toFixed(2);
            vatName = this.defaultVat.name;
          }
          if (cartItem.discounted_cost !== null) {
            vatAmount = calculateVatAmount(cartItem.quantity, cartItem.discounted_cost, vatPercentage);
          } else {
            vatAmount = calculateVatAmount(cartItem.quantity, cartItem.unit_cost, vatPercentage);
          }
        } else if (this.b2bEnabled === "false" && itemData.include_vat) {
          if (vatCategoryId) {
            const vatCategory = await fetchVatCategory(vatCategoryId);
            vatPercentage = vatCategory.percentage;
            vatName = vatCategory.name;
          } else {
            vatPercentage = parseFloat(this.defaultVat.percentage).toFixed(2);
            vatName = this.defaultVat.name;
          }
          if (cartItem.discounted_cost !== null) {
            vatAmount = calculateVatAmount(cartItem.quantity, cartItem.discounted_cost, vatPercentage);
          } else {
            vatAmount = calculateVatAmount(cartItem.quantity, cartItem.unit_cost, vatPercentage);
          }
        } else {
          vatAmount = 0;
        }
        if (vatName) {
          vatCategoryTotals[vatName] = (vatCategoryTotals[vatName] || 0) + vatAmount;
        }
        vatPercentages.push(vatPercentage || null);
        cartItem.vatAmount = parseFloat(vatAmount) || 0;
      }
      this.vatCategoryTotals = vatCategoryTotals;
      this.vatPercentages = vatPercentages;
    }
  },
  watch: {
    'cart.items': {
      immediate: true, 
      handler(newItems, oldItems) {
        if (newItems.length > 0 && oldItems.length === 0) {
          this.fetchVatPercentages(); 
        }
      },
    },
    totalVat(newValue, oldValue) {
      this.$emit('vat-total', newValue);
    }
  },
}
</script>

<style scoped>
.cart-table-total {
  /*font-weight: bold;
  font-size: 18px;*/
}
.cart-table-vat ul {
  margin-bottom:0px;
}

.cart-table-vat ul li{
  font-weight: 300;
    font-size: initial;
    list-style: none;
}
</style>